export var InspectionType;
(function (InspectionType) {
    InspectionType["BEFORE_WORK"] = "BEFORE_WORK";
    InspectionType["AFTER_WORK"] = "AFTER_WORK";
    InspectionType["BEFORE_RENT"] = "BEFORE_RENT";
    InspectionType["AFTER_RENT"] = "AFTER_RENT";
})(InspectionType || (InspectionType = {}));
;
